//alert(window.screen.width)
export const isDesktop = !(window.outerWidth <= 1024);


// WEBPACK FOOTER //
// ./src/model/deviceInfo.js